var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlusSvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "100px",
    height: "100px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(2.56,2.56)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77,12c-0.55228,0 -1,0.44772 -1,1c0,0.55228 0.44772,1 1,1c0.55228,0 1,-0.44772 1,-1c0,-0.55228 -0.44772,-1 -1,-1z",
    fill: "#a7f3d0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,13c-20.43454,0 -37,16.56546 -37,37c0,20.43454 16.56546,37 37,37c20.43454,0 37,-16.56546 37,-37c0,-20.43454 -16.56546,-37 -37,-37z",
    fill: "#c7d2fe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83,11c-2.20914,0 -4,1.79086 -4,4c0,2.20914 1.79086,4 4,4c2.20914,0 4,-1.79086 4,-4c0,-2.20914 -1.79086,-4 -4,-4z",
    fill: "#a7f3d0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87,22c-1.10457,0 -2,0.89543 -2,2c0,1.10457 0.89543,2 2,2c1.10457,0 2,-0.89543 2,-2c0,-1.10457 -0.89543,-2 -2,-2z",
    fill: "#a7f3d0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81,74c-1.10457,0 -2,0.89543 -2,2c0,1.10457 0.89543,2 2,2c1.10457,0 2,-0.89543 2,-2c0,-1.10457 -0.89543,-2 -2,-2zM15,59c-2.20914,0 -4,1.79086 -4,4c0,2.20914 1.79086,4 4,4c2.20914,0 4,-1.79086 4,-4c0,-2.20914 -1.79086,-4 -4,-4z",
    fill: "#ff68b3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,85c-1.10457,0 -2,0.89543 -2,2c0,1.10457 0.89543,2 2,2c1.10457,0 2,-0.89543 2,-2c0,-1.10457 -0.89543,-2 -2,-2z",
    fill: "#a7f3d0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5,49c-1.38071,0 -2.5,1.11929 -2.5,2.5c0,1.38071 1.11929,2.5 2.5,2.5c1.38071,0 2.5,-1.11929 2.5,-2.5c0,-1.38071 -1.11929,-2.5 -2.5,-2.5zM79.5,32c-0.82843,0 -1.5,0.67157 -1.5,1.5c0,0.82843 0.67157,1.5 1.5,1.5c0.82843,0 1.5,-0.67157 1.5,-1.5c0,-0.82843 -0.67157,-1.5 -1.5,-1.5z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M50,26.042c-13.23164,0 -23.958,10.72636 -23.958,23.958c0,13.23164 10.72636,23.958 23.958,23.958c13.23164,0 23.958,-10.72636 23.958,-23.958c0,-13.23164 -10.72636,-23.958 -23.958,-23.958z",
    fill: "#fdfcee"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,26.4c13.013,0 23.6,10.587 23.6,23.6c0,13.013 -10.587,23.6 -23.6,23.6c-13.013,0 -23.6,-10.587 -23.6,-23.6c0,-13.013 10.587,-23.6 23.6,-23.6M50,25c-13.807,0 -25,11.193 -25,25c0,13.807 11.193,25 25,25c13.807,0 25,-11.193 25,-25c0,-13.807 -11.193,-25 -25,-25z",
    fill: "#472b29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.999,30.375c-10.83914,0 -19.626,8.78686 -19.626,19.626c0,10.83914 8.78686,19.626 19.626,19.626c10.83914,0 19.626,-8.78686 19.626,-19.626c0,-10.83914 -8.78686,-19.626 -19.626,-19.626z",
    fill: "#34d399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.999,33.375c10.333,0 18.781,7.99 19.55,18.126c0.038,-0.497 0.076,-0.994 0.076,-1.5c0,-10.839 -8.787,-19.626 -19.626,-19.626c-10.839,0 -19.626,8.787 -19.626,19.626c0,0.506 0.038,1.003 0.076,1.5c0.769,-10.136 9.218,-18.126 19.55,-18.126z",
    fill: "#a7f3d0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.999,30.75c10.615,0 19.251,8.635 19.251,19.249c0,10.615 -8.636,19.251 -19.251,19.251c-10.614,0 -19.249,-8.636 -19.249,-19.251c0,-10.614 8.635,-19.249 19.249,-19.249M49.999,30c-11.027,0 -19.999,8.972 -19.999,19.999c0,11.028 8.972,20.001 19.999,20.001c11.028,0 20.001,-8.973 20.001,-20.001c0,-11.028 -8.973,-19.999 -20.001,-19.999z",
    fill: "#472b29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42,48.25c-0.965,0 -1.75,0.785 -1.75,1.75c0,0.965 0.785,1.75 1.75,1.75h6.25v6.25c0,0.965 0.785,1.75 1.75,1.75c0.965,0 1.75,-0.785 1.75,-1.75v-6.25h6.25c0.965,0 1.75,-0.785 1.75,-1.75c0,-0.965 -0.785,-1.75 -1.75,-1.75h-6.25v-6.25c0,-0.965 -0.785,-1.75 -1.75,-1.75c-0.965,0 -1.75,0.785 -1.75,1.75v6.25z",
    fill: "#fdfcee"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,40.75c0.689,0 1.25,0.561 1.25,1.25v6v0.75h0.75h6c0.689,0 1.25,0.561 1.25,1.25c0,0.689 -0.561,1.25 -1.25,1.25h-6h-0.75v0.75v6c0,0.689 -0.561,1.25 -1.25,1.25c-0.689,0 -1.25,-0.561 -1.25,-1.25v-6v-0.75h-0.75h-6c-0.689,0 -1.25,-0.561 -1.25,-1.25c0,-0.689 0.561,-1.25 1.25,-1.25h6h0.75v-0.75v-6c0,-0.689 0.561,-1.25 1.25,-1.25M50,40c-1.104,0 -2,0.895 -2,2c0,0.382 0,2.992 0,6c-3.008,0 -5.618,0 -6,0c-1.104,0 -2,0.895 -2,2c0,1.105 0.896,2 2,2c0.382,0 2.992,0 6,0c0,3.008 0,5.618 0,6c0,1.105 0.896,2 2,2c1.104,0 2,-0.895 2,-2c0,-0.382 0,-2.992 0,-6c3.008,0 5.618,0 6,0c1.104,0 2,-0.895 2,-2c0,-1.105 -0.896,-2 -2,-2c-0.382,0 -2.992,0 -6,0c0,-3.008 0,-5.618 0,-6c0,-1.105 -0.896,-2 -2,-2z",
    fill: "#472b29"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusSvg);
export default __webpack_public_path__ + "static/media/plusSVG.fbd6b9d15483fad02190d81d7eb32598.svg";
export { ForwardRef as ReactComponent };